import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export default function DoneStep({ fromVersion, toVersion, onDone }) {
  return (
    <Box sx={{ textAlign: 'center', py: 5 }}>
      <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
      <Typography variant="h5" gutterBottom>Your sensor is updated</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Updated {fromVersion || 'your sensor'} &rarr; <strong>{toVersion}</strong>
      </Typography>
      <Button variant="contained" onClick={onDone}>Done</Button>
    </Box>
  );
}
